export default __webpack_public_path__ + "static/media/Signature.8f2a001d.svg";